export default "__VITE_ASSET__DInhG1mQ__"